// Doit rester le premier import : enregistre Trusted Types avant router → seoService.
import './utils/trustedTypes'
import './assets/main.css'
import './assets/tools.css'
// Font Awesome : feuilles ciblées (évite la majeure partie du poids de all.css)
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import '@fortawesome/fontawesome-free/css/regular.min.css'
import '@fortawesome/fontawesome-free/css/brands.min.css'
import './assets/fontawesome-optimized.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { setupSecurityMiddleware } from './middleware/security'
import { setMotionApp } from './utils/motionLoader'
import { disableServiceWorker } from './utils/security'
import { initializeAnalytics, setupAnalyticsRouter } from './utils/analytics'
import { useAuthStore } from './stores/authStore'

// Note: La CSP est maintenant gérée uniquement côté serveur via les en-têtes HTTP
// pour une meilleure sécurité et conformité avec les recommandations Lighthouse

// Désactiver le service worker en développement pour éviter les conflits
if (import.meta.env.DEV) {
  disableServiceWorker()
}

// Créer l'application
const app = createApp(App)
setMotionApp(app)

// Installer Pinia
const pinia = createPinia()
app.use(pinia)

// Installer le routeur
app.use(router)
setupAnalyticsRouter(router)

// Installer i18n
app.use(i18n)

setupSecurityMiddleware(router)

document.getElementById('static-internal-linking')?.remove()

// MotionPlugin chargé à la demande (route Services) — voir router/index.ts

function removeStaticFirstPaintChrome() {
  document.getElementById('postdev-lcp-shell')?.remove()
}

// Monter l'app immédiatement — ne jamais bloquer sur une requête réseau
// avant le mount : si l'API est lente ou inaccessible, la page resterait
// blanche sans aucune erreur visible.
app.mount('#app')
// Après paint Vue : le header réel recouvre le placeholder, le hero recouvre le shell.
requestAnimationFrame(() => {
  requestAnimationFrame(removeStaticFirstPaintChrome)
})

// Init auth en arrière-plan après le mount
const authStore = useAuthStore()
authStore.initializeFromStorage()
authStore.initializeAuth().then(() => {
  initializeAnalytics()
}).catch(() => {
  initializeAnalytics()
})
